module.exports = __webpack_public_path__ + "img/screening-reject.f3a5505a.svg";